import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FeedbackSearchArgument, UserSearchArgument, distributeFormArgument, deleteResourceFormArgument, updateStatusFormArgument, updateBatchStatusFormArgument } from '@/models/feedbacks'

const URL = '/rest/customer/feedback/feedbacks'
const FORM_LIST_URL = '/rest/customer/feedback/feedbacks/form-list'
const READ_URL = '/rest/customer/feedback/feedbacks/{id}/read'
const UNREAD_URL = '/rest/customer/feedback/feedbacks/{id}/unread'
const DELETE_TODAY_URL = '/rest/customer/feedback/today-header-flow/{id}/delete'
const DELETE_URL = '/rest/customer/feedback/feedbacks/{id}'
const DELETE_CUSTOMER_URL = '/rest/customer/feedback/baidu-flow/{id}/delete'
const ITEM_URL = '/rest/customer/platform/items/all'
const OPEN_QUESTIONNAIRE_URL = '/rest/customer/feedback/feedbacks/{id}/open-questionnaires'
const READ_MUL_URL = '/rest/customer/feedback/feedbacks/read'
const DELETE_LIST_URL = '/rest/customer/feedback/feedbacks/deleteList'
const UNREAD_MUL_URL = '/rest/customer/feedback/feedbacks/unread'
const REMRAK_URL = '/rest/customer/feedback/baidu-flow/{id}'
const READ_BAIDU_URL = '/rest/customer/feedback/baidu-flow/{id}/read'
const UNREAD_BAIDU_URL = '/rest/customer/feedback/baidu-flow/{id}/unread'
const TODAY_URL = '/rest/customer/feedback/today-header-flow/{id}'
const READ_TODAY_URL = '/rest/customer/feedback/today-header-flow/{id}/read'
const UNREAD_TODAY_URL = '/rest/customer/feedback/today-header-flow/{id}/unread'
const BAIDU_DELETE_LIST_URL = '/rest/customer/feedback/baidu-flow/deleteList'
const TODAY_DELETE_LIST_URL = '/rest/customer/feedback/today-header-flow/deleteList'
const DISTRIBUTE_URL = '/rest/es/eccutomerdistribute/assignResourcesManually' // 手动分配
const BAIDU_READ_URL = '/rest/customer/feedback/baidu-flow/ids/read/many' // 百度信息流批量已读
const BAIDU_UNREAD_URL = '/rest/customer/feedback/baidu-flow/ids/unread/many' // 百度信息流批量已读
const TOUTIAO_READ_URL = '/rest/customer/feedback/today-header-flow/ids/read/many'  // 今日头条批量已读
const TOUTIAO_UNREAD_URL = '/rest/customer/feedback/today-header-flow/ids/unread/many' // 今日头条批量已读
const USER_LINKNESS_URL = '/rest/es/crmuser/like'
const USER_SPE_LINKNESS_URL = '/rest/es/crmchannelsource/like' // 模糊查询客户来源，仅限个别用户
const SPE_DISTRIBUTE_URL = '/rest/es/eccutomerdistribute/assignResourcesManuallyByChannelSource' // 手动分配资源-按客人来源，仅限个别用户
const DELETE_RESOURCE_CPCHANDLER = '/rest/customer/feedback/resourceCpchandler/delete' // 删除
const DELETE_BATCH_RESOURCE_CPCHANDLER = '/rest/customer/feedback/resourceCpchandler/deleteBatch' // 批量删除
const UPDATE_READ_STATUS = '/rest/customer/feedback/resourceCpchandler/updateReadStatus' // 已读未读
const UPDATE_BATCH_READ_STATUS = '/rest/customer/feedback/resourceCpchandler/updateReadStatusBatch' // 批量设置已读未读
const CRM_RESOURCE_TYPE_URL = '/rest/es/eccutomerdistribute/getCrmAssignResourceType' // 获取Crm资源分配的方式
const ASSIGN_RESOURCES_MANUALLY_BY_THRIDPUSH_URL = '/rest/es/eccutomerdistribute/AssignResourcesManuallyByThridPush' // 手动分配资源-直接推送

export default {
  distribute ({form}, cb) {
    const data = convert.toJson(form, distributeFormArgument)
    http.put(DISTRIBUTE_URL, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  baidudeleteList ({ids}, cb) {
    http.put(BAIDU_DELETE_LIST_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  todaydeleteList ({ids}, cb) {
    http.put(TODAY_DELETE_LIST_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  baiduReadList ({ids}, cb) {
    http.put(BAIDU_READ_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  baiduUnreadList ({ids}, cb) {
    http.put(BAIDU_UNREAD_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  toutiaoReadList ({ids}, cb) {
    http.put(TOUTIAO_READ_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  toutiaoUnreadList ({ids}, cb) {
    http.put(TOUTIAO_UNREAD_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  start (cb) {
    http.get(URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  itemTitle ({search}, cb) {
    http.get(ITEM_URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  formList ({search}, cb) {
    http.get(FORM_LIST_URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  delete ({id}, cb) {
    http.delete(DELETE_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  deleteCustomer ({id}, cb) {
    http.delete(DELETE_CUSTOMER_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  deleteToday ({id}, cb) {
    http.delete(DELETE_TODAY_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  resouceDelete (form, cb) {
    http.post(DELETE_RESOURCE_CPCHANDLER, convert.toJson(form, deleteResourceFormArgument))
    .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  resourceBatchDelete (form, cb) {
    http.post(DELETE_BATCH_RESOURCE_CPCHANDLER, form).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  updateReadStatus (form, cb) {
    http.post(UPDATE_READ_STATUS, convert.toJson(form, updateStatusFormArgument))
    .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  updateBatchReadStatus (form, cb) {
    http.post(UPDATE_BATCH_READ_STATUS, convert.toJson(form, updateBatchStatusFormArgument))
    .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  read ({id}, cb) {
    http.put(READ_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  unread ({id}, cb) {
    http.put(UNREAD_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getOpenQuestionnaire ({id}, cb) {
    http.get(OPEN_QUESTIONNAIRE_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  readMul ({ids}, cb) {
    http.put(READ_MUL_URL, {
      ids: ids
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  deleteList ({ids}, cb) {
    http.put(DELETE_LIST_URL, {
      ids: ids
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  unReadMul ({ids}, cb) {
    http.put(UNREAD_MUL_URL, {
      ids: ids
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  likeness ({search}, cb) {
    http.get(USER_LINKNESS_URL, {
      params: convert.toJson(search, UserSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  speLikeness ({search}, cb) {
    http.get(USER_SPE_LINKNESS_URL, {
      params: convert.toJson(search, UserSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  speDistribute ({form}, cb) {
    const data = convert.toJson(form, distributeFormArgument)
    http.put(SPE_DISTRIBUTE_URL, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  modifyFeedbackRemark ({id, remark}, cb) {
    http.put(DELETE_URL.replace('{id}', id), {remark: remark})
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  modifyRemark ({id, remark, tableName}, cb) {
    http.put(TODAY_URL.replace('{id}', id), {remark: remark, tableName: tableName})
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  remrakBaiDu ({id, remark}, cb) {
    http.put(REMRAK_URL.replace('{id}', id), {remark: remark})
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  readBaiDu ({id}, cb) {
    http.put(READ_BAIDU_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  unreadBaiDu ({id}, cb) {
    http.put(UNREAD_BAIDU_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  remrakToday ({id, remark}, cb) {
    http.put(TODAY_URL.replace('{id}', id), {remark: remark})
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  readToday ({id}, cb) {
    http.put(READ_TODAY_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  unreadToday ({id}, cb) {
    http.put(UNREAD_TODAY_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getCrmAssignResourceType () {
    return http.get(CRM_RESOURCE_TYPE_URL)
  },
  assignResourcesManuallyByThridPush ({form}, cb) {
    const data = convert.toJson(form, distributeFormArgument)
    http.put(ASSIGN_RESOURCES_MANUALLY_BY_THRIDPUSH_URL, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/feedback.js